export enum ROUTES {
  HOME = "/",
  WORDS = "/my-words",
  USEFUL_LINKS = "/useful-links",
  AUTH = "/auth",
  REGISTER = "/sign-up",
  RESET = "/reset-password",
  EDIT_PASSWORD = "/users/password/edit",
  COURSES = "/my-courses",
  LESSONS = "/lessons",
  REPORTS = "/reports",
  CREATIVE_TASKS = "/creative",
  EXERCISES = "/exercises",
  UNITS = "/units",

  PROFILE = "/profile",

  STUDENT_CONFIRM_EMAIL = "/confirm-email",

  SETUP_PASSWORD = "/setup-password",

  ATTENDANCE = "/attendance",
  GROUPS = "/groups",

  REPORT_STUDENTS = "/reports/students_reports",
  REPORT_TEACHERS = "/reports/teachers-reports",
  REPORT_ENTRANCE = "/reports/entrance_testings_report",
  REPORT_LICENCSE = "/reports/license_reports",

  PROMOCODE_EXPIRED = "/promocode-expired",
}

export const EXTERNAL_ROUTES: ROUTES[] = [];
